import React, { useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../../utils/hooks/use-media-query";
import "./admin-records.scss";

// Keep the desktop table and all existing column formatters/actions intact.
export default function AdminRecords(props: any) {
  const { data, columns, keyField, selectRow } = props;
  const mobile = useMediaQuery("(max-width: 991.98px)");
  const { t } = useTranslation("common");
  const [sort, setSort] = useState("");
  const [descending, setDescending] = useState(false);
  const rows = useMemo(() => {
    if (!sort) return data;
    return [...data].sort((a, b) => {
      const left = a[sort], right = b[sort];
      const result = typeof left === "number" && typeof right === "number"
        ? left - right : String(left ?? "").localeCompare(String(right ?? ""), undefined, { numeric: true });
      return descending ? -result : result;
    });
  }, [data, sort, descending]);
  if (!mobile) return <BootstrapTable {...props} />;
  const visible = columns.filter((column: any) => !column.hidden);
  return <div className="admin-records">
    <div className="admin-records-tools">
      <label>{t("Sort by")}
        <select value={sort} onChange={event => setSort(event.target.value)}>
          <option value="">{t("Default order")}</option>
          {visible.filter((column: any) => column.sort).map((column: any) =>
            <option key={column.dataField} value={column.dataField}>{column.text}</option>)}
        </select>
      </label>
      <button type="button" disabled={!sort} onClick={() => setDescending(!descending)}>
        {t(descending ? "Descending" : "Ascending")}
      </button>
      {visible.filter((column: any) => column.headerFormatter).map((column: any, index: number) =>
        <div key={index} className="admin-records-header-action">{column.headerFormatter(column, index)}</div>)}
    </div>
    {rows.length === 0 && <p role="status">{t("No records found")}</p>}
    {rows.map((row: any, index: number) => <article key={row[keyField]} className="admin-record-card">
      {selectRow && <label className="admin-record-selection">
        <input type="checkbox" checked={selectRow.selected?.includes(row[keyField]) || false}
          disabled={selectRow.nonSelectable?.includes(row[keyField])}
          onChange={event => selectRow.onSelect(row, event.target.checked, index, event)} />
        {t("Select record")} {index + 1}
      </label>}
      <dl>{visible.map((column: any, columnIndex: number) => <div key={columnIndex}>
        <dt>{column.text || t("Actions")}</dt>
        <dd>{column.formatter ? column.formatter(row[column.dataField], row, index, column.formatExtraData) : row[column.dataField] ?? "—"}</dd>
      </div>)}</dl>
    </article>)}
  </div>;
}
